export default __webpack_public_path__ + "static/media/flag-central-african-republic.8ba743c6.svg";